// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".research-directions-banner[data-v-547fe2c4]{background-position:bottom;background-size:cover;font-weight:500}.research-directions-banner__link[data-v-547fe2c4]{-webkit-text-decoration:none;text-decoration:none}.research-directions-banner__text[data-v-547fe2c4]{font-size:20px}.research-directions-banner__button[data-v-547fe2c4]{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
